import React, {useState, useEffect, useRef, useCallback, useReducer, useMemo} from 'react';
import styled from 'styled-components';

import Lottie from 'react-lottie-player'

import useDimensions from "react-cool-dimensions";

import lottieJson from '../../assets/lottie/loading_lottie.json'

export default function LoadingLottieLoader(props) {
    const {observe, unobserve, width, height, entry} = useDimensions({
        onResize: ({observe, unobserve, width, height, entry}) => {

        }
    });

    return (
        <Wrapper ref={observe}>
            <Lottie
                loop
                animationData={lottieJson}
                play
                style={{width: width * 0.5, height: height * 0.5}}
            />
        </Wrapper>
    );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;